import { createAction, props } from '@ngrx/store';

export enum CaensActions {
  CaensRequested = '[Caens] Caens Requested',
  CaensLoaded = '[Caens] Caens Loaded',
  CaensError = '[Caens] Caens Error'
}

export const CaensRequested = createAction(CaensActions.CaensRequested);

export const CaensLoaded = createAction(CaensActions.CaensLoaded,
    props<{ caens: [] }>());

export const CaensError = createAction(CaensActions.CaensError);
